import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Http, Headers, RequestOptions } from '@angular/http';


export class autoComplValues {
    constructor(public name: string, public valueType: string, 
        public firstName? : string, 
        public email? : string, public image? : string, 
        public id? : string, public type? : string, public typePlaceholder? : string) { }
  }

@Injectable()
export class StoreService {

  constructor( private http : Http) { }

  allUsers: any; 
  searchedSkills = []
  searchedSkills_array= []; 
  searchedSkills_object: any; 
  searchedSkills_inMemory: any; 
  filteredUsers: any; 
  currentUser: any; 
  options: any;
  profile: any
  skills: any
  editMode = false 
  editModeGlobal = false
  autocomplValues: autoComplValues[] = []
  autocomplSkills = false
  autocomplProfiles = false
  resetSearchedSkills = true
  disabled = false
  levels = []
  router = {
      profile: false, 
      params: null
  }






  /* Authentication */ 
  
  setToken(token) {
    // Defines Headers which will be appended to every cloud function request
    const headers = new Headers();
    headers.append('authorization', 'Bearer ' + token);
    this.options = new RequestOptions({headers: headers});
  }

  getCurrentUser() {
    // Get the basic user infos (name, mail, photo) from the authentication, and create or update
    // user informations in the MySQL db if needed 
    this.http.get(environment.apiURL + 'getCurrentUser', this.options)
      .map( res => res.json())
      .subscribe(data => {
          this.currentUser = data; 
          if (this.currentUser.photoURL === "undefined") {this.currentUser.photoURL = '/assets/user.png'}
  })}







  /* Loads all the data from the MySQL Db at the launch of the app */ 

  fetchAllData() {
    var p1 = this.fetchAllUsers()
    var p2 = this.getSkills()
    var p3 = this.getLevelSchema()
    return Promise.all([p1, p2, p3])
  }
  
  fetchAllUsers() {
    // Gets all the users data 
    return new Promise((resolve, reject) => {
    this.http
      .get(environment.apiURL + 'loadUsers', this.options )
      .map(res => res.json())
      .subscribe(
        res => {
          this.allUsers = res;
          resolve(res)                    
          this.allUsers.forEach(
            u => { u.skills.forEach(
                s => s.likes.forEach(
                    l => {
                        l.likeId === null ? s.likes = [] : null
                        return l.likeId !== null}))
          })
          for (var i=0; i<this.allUsers.length; i++) {
              /* In case the user photo is undefined */ 
              if (this.allUsers[i].photoURL === "undefined") {
                  this.allUsers[i].photoURL = '/assets/user.png'}
              /* To get the first and family names from the auth infos */ 
              var splittedName = this.allUsers[i].displayName.split(' ') 
              this.allUsers[i].familyName = splittedName.pop()
              var foo = ''
              splittedName.forEach(el => foo = foo + el + ' ')
              this.allUsers[i].firstName = foo
          }
          /* Populates the autocompletion variable (search bar) with the fetched profiles */ 
          if (this.autocomplProfiles === false) {
          for (var i=0; i<this.allUsers.length; i++) {
                  this.autocomplValues.push({
                      name : this.allUsers[i].displayName,
                      valueType: 'email', 
                      email : this.allUsers[i].email,
                      image :  this.allUsers[i].photoURL
                  })
                  this.autocomplProfiles = true;}
          }
        },
        err => reject(err)
      )
  })}

  getSkills() {
    // Gets all the skill names 
    return new Promise((resolve, reject) => {
        this.http.get(environment.apiURL + 'getSkills', this.options)
        .map(res => res.json())
        .subscribe(
          /* Populates the autocompletion variable (search bar) with the fetched profiles */ 
          data => { this.skills = data; resolve(data);
            this.autocomplSkills === false ? (this.skills.forEach(
                s => (s.categories.forEach(
                    c => (c.category ? 
                         /* If there is a 'catagory' level, for example for the skills of type 'tools' */ 
                         (this.autocomplValues.push(  
                           {name: c.category, 
                            valueType: 'family', 
                            type: s.type,
                            typePlaceholder: 'Domaine' }), 
                            c.skills.forEach( cs => this.autocomplValues.push(
                               {name: cs.name,
                                id: cs.id,
                                valueType: 'skill', 
                                type: c.category ? c.category : s.type, 
                                typePlaceholder: c.category ? 'Famille' : 'Domaine'}
                            ))) 
                         : 
                         /* If there is no 'catagory' level */ 
                         c.skills.forEach(cs => this.autocomplValues.push(
                           {name: cs.name,
                            id: cs.id,
                            valueType: 'skill', 
                            type: c.category ? c.category : s.type, 
                            typePlaceholder: c.category ? 'Famille' : 'Domaine'}
                         ))
                        ))),
                    this.autocomplSkills = true)
                    ) : '' },
            err => { reject(err) }
        )
    })
  };

  getLevelSchema() {
    /* Gets the levels labels */ 
    return new Promise((resolve, reject) => {
        this.http.get(environment.apiURL + 'getLevels', this.options)
        .map(res => res.json())
        .subscribe( data => { resolve(data); this.levels = data})
    })}







  /* Query a profile */ 

  getProfile(email) {
    // Retrieves a requested profile in the allUsers variable
    email === this.currentUser.email ? this.editModeGlobal = true : this.editModeGlobal = false
    var findProfile = p => {
        this.profile = this.allUsers.find(u => u.email === p)
        this.profile.photoURL = this.profile.photoURL || '/assets/user.png'}
    this.allUsers ? (
        findProfile(email)) : this.fetchAllData().then(() => findProfile(email)) 
  }






    /* CRUD operations on profile skills */ 

    addSkill(form, type) {
        form = {
            id: Date.now().toString(),
            email: this.currentUser.email,
            category: form.categ, 
            skillId: form.domain.val,
            skillName: form.domain.name,
            level: form.level.val,
            likes: [],
            type: type,
            certified: form.certified
        }
        return new Promise((resolve, reject) => {
            this.http
            .post(environment.apiURL + 'addSkill', form, this.options)
            .subscribe(
                () => { this.profile.skills.unshift(form); resolve('done') },
                err => reject(err)
            )
        })
    }

    deleteSkill(id) {
        return new Promise((resolve, reject) => {
            this.http.post(environment.apiURL + 'deleteSkill', { id }, this.options)
            .subscribe(
                () => {
                    this.profile.skills = this.profile.skills.filter(s => s.id !== id);
                    resolve('done')
                },
                err => reject(err)
            )
        })
    }

    updateSkill(form, $id) {
        var updatedSkill = this.profile.skills.find(
            skill => skill.id === $id
        )

        form = {
            id: $id,
            skillId: form.domain.val || updatedSkill.skillId,
            skillName: form.domain.name || updatedSkill.skillName,
            level: form.level.val || updatedSkill.level, 
            certified: form.certified || updatedSkill.certified
        }

        return new Promise((resolve, reject) => {
            this.http.post(environment.apiURL + 'updateSkill', form, this.options)
            .subscribe(
                () => {
                    let skill = this.profile.skills.find(s => s.id === form.id) 
                    skill.skillName = form.skillName
                    skill.level = form.level
                    skill.certified = form.certified
                    resolve('done')
                    if (skill.certified === "false") {
                        skill.certified = false}
                    if (skill.certified === "true") {
                        skill.certified = true}
                },
                err => reject(err)
            )
        })
    }





    /* Likes */ 

    likeSkill(userSkillId) {
        let skill = this.profile.skills.find(skill => skill.id === userSkillId)
        let like = skill.likes.find(like => like.endorser ? like.endorser.email === this.currentUser.email : false)
        like = like || { userSkillId, likeId: Date.now().toString(), endorser: this.currentUser.email, new: true }
        return new Promise((resolve, reject) => {
            this.http
            .post(environment.apiURL + 'likeSkill', like, this.options)
            .subscribe(
                () => {
                    if(like.new) { 
                        delete like.new; 
                        var e = this.allUsers.find( u => u.email === like.endorser)
                        like.endorser = { email: e.email, photoURL: e.photoURL }
                        skill.likes.unshift(like) }
                    else {
                        skill.likes = skill.likes.filter(l => l.likeId != like.likeId)}
                    resolve('done')
                },
                err => reject(err)
            )
        })
    }





    /* Aliases */ 
    
    typeAlias(type) {
        switch (type) {
            case "expertise": return "Expertise"
            case "tool": return "Outils"
            case "IT langage": return "Langage informatique"
            case "langage": return "Langue"
            default: return ""
          }
    }

    typeIcon(type) {
    // to add custom images for domains in the auto-completion search
        switch (type) {
            case "expertise": return "/assets/settings.png"
            case "tool": return "/assets/settings.png"
            case "IT langage": return "/assets/settings.png"
            case "langage": return "/assets/settings.png"
            default: return ""
          }
    }




    /* Additionnals */ 

    getSkillCategories(type) {
        var s = this.skills.find(skill => {return skill.type === type})
        if (s) {
            if (s.categories) {
                s.categories.sort((a, b) => a.category.localeCompare(b.category))
                s.categories.forEach(
                    x => x.skills.sort((a, b) => a.name.localeCompare(b.name)))}
        return s.categories ? s.categories : []}
        else return []
    }

    getTypeSkills(type) {
        // Retrieves a set of skills according to its type
        var s = this.skills.find(skill =>  skill.type === type)
        if (s) {
            s.categories[0] = s.categories[0] || []
            s.categories.sort((a, b) => a.category.localeCompare(b.category))
            s.categories.forEach(
                x => x.skills.sort((a, b) => a.name.localeCompare(b.name))
            )
            return s.categories.length === 1 ? s.categories[0].skills : s.categories }
        else return []
    }


  autoComplete(req) {
    // populates the autocompletion variable with the entries matching the request 
    return this.autocomplValues.filter(function (el) {
      return el.name.toLowerCase().indexOf(req.toLowerCase()) > -1;})
  }



}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/store.service.ts